import { Pipe, PipeTransform } from '@angular/core';
import { PRINTED } from '../../../ngrx/status-types';

@Pipe({
  name: 'jobPrintStation'
})
export class JobPrintStationPipe implements PipeTransform {
  transform(jobs: any[], printStation: string): any[] {
    return jobs.filter(job => {
      return printStation === 'ALL'
        ? job.status === PRINTED
        : job.status === PRINTED && job.jobLocation === printStation;
    });
  }
}


// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/app/shared/pipes/job-print-station.pipe.ts